/**
 * Crée une annonce pour les lecteurs d'écran
 * @param message - Message à annoncer
 */
export function createAnnouncement(message: string): void {
    // Supprimer l'ancienne annonce si elle existe
    const existingAnnouncement: HTMLElement | null = document.getElementById('screen-reader-announcement');
    if (existingAnnouncement) {
        existingAnnouncement.remove();
    }

    // Créer une nouvelle annonce
    const announcement: HTMLElement = document.createElement('div');
    announcement.id = 'screen-reader-announcement';
    announcement.setAttribute('role', 'alert');
    announcement.className = 'visually-hidden';
    announcement.textContent = message;

    // Insérer au début du body pour garantir qu'elle soit lue en premier
    if (document.body.firstChild) {
        document.body.insertBefore(announcement, document.body.firstChild);
    } else {
        document.body.appendChild(announcement);
    }
}
